import {lazy} from './lazyLoading'
/**
 * 拼接动态路由
 */
export default (routerList,routeHideList, sysMenuList) => {
    toRoutes(routerList,routeHideList, sysMenuList)
}
function toRoutes(routerList,routeHideList, sysMenuList) {
    if (sysMenuList) {
        sysMenuList.forEach(item=>{
            if(!item.children) return
            var sysMenuList = item.children
            for (var i = 0; i < sysMenuList.length; i++) {
                var sysMenuNode = sysMenuList[i];
                if (sysMenuNode.resoure_url) {
                    var code=sysMenuNode.permission;
                    const lazyRoute = lazy(code)
                    if (!lazyRoute) {
                      continue
                    }
                    var routeNode = {
                        name: code,
                        path: '/' + code,
                        redirect: lazyRoute.redirect,
                        component: lazyRoute.component,
                        meta: { ...lazyRoute.meta, title: sysMenuNode.text },
                        children:[]
                    };
                    //子节点存在
                    if (sysMenuNode.children && sysMenuNode.children.length > 0) {
                        toRoutes(routeNode.children,routeHideList,sysMenuNode.children);
                    }
                    if(code&&code!=''){
                            routerList.push(routeNode);
                    }
                    //子节点存在
                    if (sysMenuNode.children && sysMenuNode.children.length > 0) {
                        toRoutes(routerList,routeHideList,sysMenuNode.children);
                    }   
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/store/components/convertRoutes.js